import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { TemplateReferenceService, TemplateType } from 'projects/lib_util/src/public-api';

import { NavigationHelper } from '../../helpers/navigation.helper';
import { NavigationSegment } from '../../models/breadcrumb/breadcrumb-item.model';

@Component({
  selector: 'spv2-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  breadcrumbItems: NavigationSegment[];
  
  linkTemplate: TemplateRef<any>;

  additionalTemplates: TemplateRef<any>[];

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private templateReferenceService: TemplateReferenceService) { }

  ngOnInit() {
    this.router.events.subscribe((val) => {
      if(val instanceof NavigationEnd) {
        this.breadcrumbItems = NavigationHelper.getNaviationSegments(this.activatedRoute);
        this.getTemplates();
      }
    });
  }
  getTemplates() {
    this.additionalTemplates = []; 
    this.templateReferenceService.getTemplates(TemplateType.Breadcrumb).subscribe(x => {
      this.additionalTemplates.push(x);
    } );
    this.templateReferenceService.getLinkTemplate().subscribe(x => {
      this.linkTemplate = x;
    } );
  }
}
